<template>
    <router-link :to="{name: 'ArtifactDetail', params: {id: asset.id}}">
        <article :class="{folder: layout_type === 'artifacts'}">
            <img :src="asset.thumbnail" alt="" width="180" height="180" loading="lazy" decoding="async">
            <template v-if="asset.artifact!== null && asset.artifact.sites !== null && asset.artifact.sites.length > 0">
              <span v-for="(site,index) in asset.artifact.sites" :key="index"
                    :class="getAreasBySite(site)">{{site.title}}</span>
            </template>
            <template v-else>
                <span class="jomon-archaeological-sites">{{$t('site_title')}}</span>
            </template>
            <h3>{{asset.title}}</h3>
        </article>
    </router-link>
</template>

<script>
export default {
    name: "AssetItem",
    props: {
        asset: {
            type: Object
        },
        layout_type: {
            type: String,
            default: 'asset'
        }
    },
    methods: {
        getAreasBySite(site) {
            if(site.area.parent !== null){
                return site.area.parent_slug;
            }else{
                return site.area.slug
            }
        },
    }
}
</script>

<style scoped>

</style>
